import React from 'react';
import classNames from 'classnames';
import { SectionTilesProps } from '../../utils/SectionProps';
import SectionHeader from './partials/SectionHeader';

// 1. Importaj slike
import ExploreImage from '../../assets/images/Explore galaxy.png';
import DeployImage from '../../assets/images/Deploy fleets.png';
import TechImage from '../../assets/images/Tech research.png';
import ResourceImage from '../../assets/images/Resource mining.png';
import EarnImage from '../../assets/images/Play to earn.png';
import OnchainImage from '../../assets/images/Onchain.png';

const propTypes = {
  ...SectionTilesProps.types
};

const defaultProps = {
  ...SectionTilesProps.defaults
};

class Providers extends React.Component {
  render() {
    const {
      className,
      topOuterDivider,
      bottomOuterDivider,
      topDivider,
      bottomDivider,
      hasBgColor,
      invertColor,
      pushLeft,
      ...props
    } = this.props;

    const outerClasses = classNames(
      'features-tiles section',
      topOuterDivider && 'has-top-divider',
      bottomOuterDivider && 'has-bottom-divider',
      hasBgColor && 'has-bg-color',
      invertColor && 'invert-color',
      className
    );

    const innerClasses = classNames(
      'features-tiles-inner section-inner',
      topDivider && 'has-top-divider',
      bottomDivider && 'has-bottom-divider'
    );

    const tilesClasses = classNames(
      'tiles-wrap',
      pushLeft && 'push-left'
    );

    const sectionHeader = {
      title: 'Moons Game Features',
      paragraph: 'Moons is a Web3-powered galaxy strategy game.'
    };

    return (
      <section {...props} className={outerClasses}>
        <div className="container">
          <div className={innerClasses}>
            <SectionHeader data={sectionHeader} className="center-content" />

            <div className={tilesClasses}>
              {/* Explore Galaxy */}
              <div className="tiles-item reveal-from-bottom">
                <div className="tiles-item-inner">
                  {/* slika */}
                  <div>
                    <img src={ExploreImage} alt="Explore Galaxy" width={320} height={320} />
                  </div>
                  <p className="m-0 text-sm">
                    Scan sectors to find resources, planets, and allies.
                  </p>
                </div>
              </div>

              {/* Deploy Fleets */}
              <div className="tiles-item reveal-from-bottom" data-reveal-delay="200">
                <div className="tiles-item-inner">
                  {/* slika */}
                  <div>
                    <img src={DeployImage} alt="Deploy Fleets" width={320} height={320} />
                  </div>
                  <p className="m-0 text-sm">
                    Build and send combat or trade fleets to expand your empire.
                  </p>
                </div>
              </div>

              {/* Tech Research */}
              <div className="tiles-item reveal-from-bottom" data-reveal-delay="200">
                <div className="tiles-item-inner">
                  {/* slika */}
                  <div>
                    <img src={TechImage} alt="Deploy Fleets" width={320} height={320} />
                  </div>
                  <p className="m-0 text-sm">
                    Upgrade ships, defenses, and mining efficiency through research.
                  </p>
                </div>
              </div>
            </div>

            <div className={tilesClasses}>
              {/* Resource Mining */}
              <div className="tiles-item reveal-from-bottom" data-reveal-delay="200">
                <div className="tiles-item-inner">
                  {/* slika */}
                  <div>
                    <img src={ResourceImage} alt="Deploy Fleets" width={320} height={320} />
                  </div>
                  <p className="m-0 text-sm">
                    Harvest metal, crystal, and deuterium for building and upgrades.
                  </p>
                </div>
              </div>
                
              {/* Play to Earn */}
              <div className="tiles-item reveal-from-bottom" data-reveal-delay="200">
                <div className="tiles-item-inner">
                  {/* slika */}
                  <div>
                    <img src={EarnImage} alt="Deploy Fleets" width={320} height={320} />
                  </div>
                  <p className="m-0 text-sm">
                    Earn RXCG tokens ingame by sending fleets to expeditions and more.
                  </p>
                </div>
              </div>

              {/* On-Chain Token */}
              <div className="tiles-item reveal-from-bottom" data-reveal-delay="200">
                <div className="tiles-item-inner">
                  {/* slika */}
                  <div>
                    <img src={OnchainImage} alt="Deploy Fleets" width={320} height={320} />
                  </div>
                  <p className="m-0 text-sm">
                    Moons game is utilizing Blockchain Web3 technology for transparency.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

Providers.propTypes = propTypes;
Providers.defaultProps = defaultProps;

export default Providers;
